import { defineComponent as _defineComponent } from 'vue'
import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import { resetVuelidateErrors } from "@/helpers/vuelidate";
  import store from "@/store";
  import useVuelidate from "@vuelidate/core";
  import { minLength, maxLength, required } from "@vuelidate/validators";
  import { computed, onMounted, ref } from "vue";
  import { useRoute } from "vue-router";
  import dayjs from "dayjs";
  import getUserRole from "@/helpers/getUserRole";

  interface Params {
    estateId: string;
    leadId?: string;
    customerId?: string;
    landownerId?: string;
    text?: string;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Notes',
  setup(__props, { expose: __expose }) {
  __expose();

  const note = ref("");
  const estateId = computed(() => {
    return store.state.user.selectedEstateId;
  });

  const route = useRoute();
  const customerId = computed(() => {
    return route.params.id;
  });
  const isLeadDetailsPage = computed(() => {
    return route.name === "LeadDetails";
  });
  const { isLandownerRole } = getUserRole();

  onMounted(() => {
    getComments();
  });

  const comments = ref([]);
  const loading = ref(false);
  const getComments = () => {
    loading.value = true;
    const params: Params = {
      estateId: estateId.value as string,
      leadId: customerId.value as string,
      customerId: customerId.value as string,
    };

    if (isLeadDetailsPage.value) {
      delete params.customerId;
    } else {
      delete params.leadId;
    }

    store
      .dispatch("userComments/getComments", params)
      .then((res) => {
        comments.value = res.data;
      })
      .finally(() => {
        loading.value = false;
      });
  };

  const rules = {
    note: { required, minLength: minLength(3), maxLength: maxLength(1000) },
  };
  const v$ = useVuelidate(rules, { note }, { $lazy: true });

  const addNote = () => {
    v$.value.$touch();

    if (v$.value.$invalid) {
      return;
    }

    const params: Params = {
      estateId: estateId.value as string,
      leadId: customerId.value as string,
      customerId: customerId.value as string,
      landownerId: isLandownerRole.value
        ? store.state.user.data._id
        : store.state.user.data.detailsId.landownerId,
      text: note.value,
    };

    if (isLeadDetailsPage.value) {
      delete params.customerId;
    } else {
      delete params.leadId;
    }

    store.dispatch("userComments/addComment", params).then(() => {
      note.value = "";
      resetVuelidateErrors(v$);
      getComments();
    });
  };

  const deleteComment = (id: string) => {
    store
      .dispatch("userComments/deleteComment", {
        id,
        estateId: estateId.value,
      })
      .then(() => {
        getComments();
      });
  };

  const idForEdit = ref("");
  const noteEdit = ref("");
  const rulesEdit = {
    noteEdit: { required, minLength: minLength(3), maxLength: maxLength(1000) },
  };
  const vEdit$ = useVuelidate(rulesEdit, { noteEdit }, { $lazy: true });

  function editComment(id: string, text: string) {
    idForEdit.value = id;
    noteEdit.value = text;
  }

  const confirm = () => {
    vEdit$.value.$touch();

    if (vEdit$.value.$invalid) {
      return;
    }

    store
      .dispatch("userComments/editComment", {
        id: idForEdit.value,
        estateId: estateId.value,
        text: noteEdit.value,
      })
      .then(() => {
        cancel();
        getComments();
      });
  };

  function cancel() {
    idForEdit.value = "";
    noteEdit.value = "";
  }

const __returned__ = { note, estateId, route, customerId, isLeadDetailsPage, isLandownerRole, comments, loading, getComments, rules, v$, addNote, deleteComment, idForEdit, noteEdit, rulesEdit, vEdit$, editComment, confirm, cancel, DropDown, get resetVuelidateErrors() { return resetVuelidateErrors }, get store() { return store }, get useVuelidate() { return useVuelidate }, get minLength() { return minLength }, get maxLength() { return maxLength }, get required() { return required }, computed, onMounted, ref, get useRoute() { return useRoute }, get dayjs() { return dayjs }, get getUserRole() { return getUserRole } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})